import type { Dispatch, SetStateAction } from 'react';
import { useCallback } from 'react';

export function useHandleRowClick<T>(
  setSelectedRowData: Dispatch<SetStateAction<T | undefined>>
) {
  return useCallback(
    (record: T) => {
      setSelectedRowData((selected) =>
        selected !== record ? record : undefined
      );
    },
    [setSelectedRowData]
  );
}
